import React from 'react';
import { Button, Popover } from 'antd';
import { DownOutlined, TagFilled } from '@ant-design/icons';
import { LABEL_PREDEFINED_COLORS, generateRandomColor } from '../../constants/labelConstants';
import { cn } from '../../utils/ClassNamesUtils';
import './ColorPicker.less';

const SELECTED_SWATCH_CLASS = 'rounded-sm outline outline-1 outline-offset-2 outline-grey-10';

type ColorPickerProps = {
	currentColor: string;
	onColorChange: (color: string) => void;
	visible: boolean;
	onVisibleChange: (visible: boolean) => void;
	buttonDisplay?: React.ReactNode;
};

export const ColorPicker: React.FC<ColorPickerProps> = ({
	currentColor,
	onColorChange,
	visible,
	onVisibleChange,
	buttonDisplay,
}) => {
	const selectedColor = currentColor ? currentColor.toLowerCase() : null;

	const offGridColor =
		currentColor && LABEL_PREDEFINED_COLORS.indexOf(selectedColor) === -1 ? currentColor : null;

	const pickSwatch = (color: string) => {
		onColorChange(color);
		onVisibleChange(false);
	};

	const popoverContent = (
		<div className="flex flex-col gap-3">
			<div className="grid grid-cols-6 gap-3">
				{LABEL_PREDEFINED_COLORS.map((color) => (
					<TagFilled
						key={color}
						onClick={() => pickSwatch(color)}
						className={cn(
							'cursor-pointer text-base',
							color === selectedColor && SELECTED_SWATCH_CLASS
						)}
						style={{ color }}
						title={color}
					/>
				))}
			</div>
			<div className="border-0 border-t border-solid border-grey-4" />
			<div className="flex items-center gap-2">
				<Button
					size="small"
					onClick={() => onColorChange(generateRandomColor())}
					className="flex-1 !rounded-[2px] !text-character-primary"
				>
					RANDOMIZE
				</Button>
				{offGridColor ? (
					<TagFilled
						onClick={() => onVisibleChange(false)}
						className="shrink-0 cursor-pointer text-base"
						style={{ color: offGridColor }}
						title={offGridColor}
					/>
				) : null}
			</div>
		</div>
	);

	return (
		<Popover
			content={popoverContent}
			overlayClassName="label-color-picker"
			trigger="click"
			visible={visible}
			onVisibleChange={onVisibleChange}
		>
			{buttonDisplay ? (
				buttonDisplay
			) : (
				<Button className="shadow-sm">
					<span
						className="inline-block h-3 w-3 rounded-full"
						style={{ backgroundColor: currentColor }}
					/>
					<DownOutlined size={12} className="mt-px h-3 w-3 text-gray-600" />
				</Button>
			)}
		</Popover>
	);
};
